import React from "react";
import CategoryNames from "../modules/CategoryNames/CategoryNames";

export default function CategoryNamesPage() {
  return <CategoryNames />;
}
